// A flow's trace key (core request.NoteTrace: "<kind>:<id>", never a
// secret; auth's SSO sign-in steps carry "signin:<hex>", a one-way key of
// the sign-in token) in words.
const KINDS = { signin: 'sign-in attempt' }

export const traceKind = key => String(key || '').split(':')[0]

// "sign-in attempt" (a kind nothing words: "flow")
export const traceLabel = key => KINDS[traceKind(key)] || 'flow'

// The first 8 characters of the id, for a chip or a summary.
export const traceShort = key => `${String(key || '').split(':').slice(1).join(':').slice(0, 8)}…`

// "Sign-in attempt 01234567…"
export const traceChip = key => {
  const label = traceLabel(key)
  return `${label.charAt(0).toUpperCase()}${label.slice(1)} ${traceShort(key)}`
}
